import React, { useState } from "react";
import {
  Award,
  TrendingUp,
  Sparkles,
  CheckCircle2,
  Loader2,
  ArrowLeft,
} from "lucide-react";

const API_URL = import.meta.env.VITE_API_URL;

const mentors = [
  {
    id: 1,
    name: "massahi",
    displayName: "Massahi",
    targetMarket: "همه بازارها",
    experience: "11 سال",
    description:
      "تجربه‌ی چندین ساله در بازارهای مالی و تحلیل فرصت‌های مختلف سرمایه‌گذاری.",
    photo: "/assets/images/massahi.jpg",
  },
  {
    id: 2,
    name: "mohammad",
    displayName: "Mohammad",
    targetMarket: "Forex",
    experience: "14 سال",
    description:
      "متخصص بازار فارکس با تجربه‌ی بالا در تحلیل بازار، مدیریت ریسک و معامله‌گری.",
    photo: "/assets/images/mammad.jpg",
  },
];

const FinancialMentors = () => {
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [loadingMentor, setLoadingMentor] = useState(null);

  const selectMentor = async (mentorName) => {
    try {
      setLoadingMentor(mentorName);

      const response = await fetch(`${API_URL}/set_mentor`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mentor: mentorName,
        }),
        credentials: "include",
      });

      const data = await response.json();

      if (data.redirect) {
        alert("برای انتخاب منتور ابتدا وارد حساب کاربری شوید.");
        window.location.href = data.redirect;
        return;
      }

      if (!response.ok) {
        console.error(data.error || "Request failed");
        return;
      }

      setSelectedMentor(mentorName);
    } catch (error) {
      console.error("Error setting mentor:", error);
    } finally {
      setLoadingMentor(null);
    }
  };

  return (
    <div style={styles.page}>
      {/* BACKGROUND EFFECTS */}
      <div style={styles.glowOne} />
      <div style={styles.glowTwo} />

      <div style={styles.container}>
        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.badge}>
            <Sparkles size={15} />
            DeepMine Mentors
          </div>

          <h1 style={styles.title}>
            منتور خودتو انتخاب کن
          </h1>

          <p style={styles.subtitle}>
            از تجربه‌ی حرفه‌ای‌های بازار استفاده کن و دستیار هوش مصنوعی خودت
            رو با سبک منتور موردنظرت شخصی‌سازی کن.
          </p>

          <div style={styles.warning}>
            <Sparkles size={16} />
            دستیار هوش مصنوعی نسخه‌ی دیجیتال منتورهاست و جایگزین مشاوره مستقیم
            آن‌ها نیست.
          </div>
        </div>

        {/* MENTORS */}
        <div style={styles.grid}>
          {mentors.map((mentor) => {
            const isSelected = selectedMentor === mentor.name;
            const isLoading = loadingMentor === mentor.name;

            return (
              <div
                key={mentor.id}
                style={{
                  ...styles.card,
                  ...(isSelected ? styles.selectedCard : {}),
                }}
              >
                {/* IMAGE */}
                <div style={styles.imageWrapper}>
                  <img
                    src={mentor.photo}
                    alt={mentor.displayName}
                    style={styles.photo}
                  />

                  <div style={styles.imageOverlay} />

                  <div style={styles.experienceBadge}>
                    <Award size={14} />
                    {mentor.experience} تجربه
                  </div>

                  {isSelected && (
                    <div style={styles.selectedBadge}>
                      <CheckCircle2 size={15} />
                      انتخاب شده
                    </div>
                  )}
                </div>

                {/* CONTENT */}
                <div style={styles.cardContent}>
                  <div style={styles.mentorHeader}>
                    <div>
                      <p style={styles.mentorLabel}>MENTOR</p>
                      <h3 style={styles.name}>{mentor.displayName}</h3>
                    </div>

                    <div style={styles.marketIcon}>
                      <TrendingUp size={22} />
                    </div>
                  </div>

                  <div style={styles.marketBox}>
                    <span style={styles.marketTitle}>بازار تخصصی</span>
                    <span style={styles.marketValue}>
                      {mentor.targetMarket}
                    </span>
                  </div>

                  <p style={styles.description}>{mentor.description}</p>

                  <button
                    disabled={isLoading || isSelected}
                    onClick={() => selectMentor(mentor.name)}
                    style={{
                      ...styles.button,
                      ...(isSelected ? styles.selectedButton : {}),
                    }}
                  >
                    {isLoading ? (
                      <>
                        <Loader2
                          size={18}
                          style={{
                            animation: "spin 1s linear infinite",
                          }}
                        />
                        در حال انتخاب...
                      </>
                    ) : isSelected ? (
                      <>
                        <CheckCircle2 size={18} />
                        منتور فعال
                      </>
                    ) : (
                      <>
                        انتخاب این منتور
                        <ArrowLeft size={18} />
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          @media (max-width: 768px) {
            .mentor-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  page: {
    position: "relative",
    overflow: "hidden",
    minHeight: "100vh",
    padding: "80px 24px",
    direction: "rtl",
    fontFamily: "Vazirmatn, Arial, sans-serif",

    background:
      "radial-gradient(circle at top, #10251f 0%, #07110f 35%, #030706 100%)",

    color: "#fff",
  },

  container: {
    position: "relative",
    zIndex: 2,
    maxWidth: "1050px",
    margin: "0 auto",
  },

  header: {
    maxWidth: "700px",
    margin: "0 auto 55px",
    textAlign: "center",
  },

  badge: {
    width: "fit-content",
    margin: "0 auto 20px",

    display: "flex",
    alignItems: "center",
    gap: "7px",

    padding: "7px 14px",

    borderRadius: "999px",

    border: "1px solid rgba(52, 211, 153, 0.22)",

    backgroundColor: "rgba(16, 185, 129, 0.08)",

    color: "#6ee7b7",

    fontSize: "12px",
    fontWeight: "600",

    letterSpacing: "0.7px",
  },

  title: {
    fontSize: "clamp(32px, 5vw, 52px)",
    lineHeight: "1.25",

    margin: "0 0 18px",

    fontWeight: "900",

    letterSpacing: "-1px",

    background:
      "linear-gradient(90deg, #ffffff 20%, #a7f3d0 60%, #34d399 100%)",

    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    margin: "0 auto",

    maxWidth: "620px",

    fontSize: "16px",
    lineHeight: "2",

    color: "#94a3b8",
  },

  warning: {
    margin: "24px auto 0",

    width: "fit-content",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",

    padding: "10px 16px",

    borderRadius: "10px",

    color: "#a7f3d0",

    background: "rgba(16, 185, 129, 0.06)",

    border: "1px solid rgba(16, 185, 129, 0.12)",

    fontSize: "12px",
  },

  grid: {
    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",

    gap: "28px",

    maxWidth: "850px",

    margin: "0 auto",
  },

  card: {
    overflow: "hidden",

    borderRadius: "22px",

    border: "1px solid rgba(255, 255, 255, 0.08)",

    background:
      "linear-gradient(145deg, rgba(15,23,42,0.82), rgba(5,12,10,0.9))",

    backdropFilter: "blur(18px)",

    boxShadow: "0 24px 70px rgba(0,0,0,0.35)",

    transition: "all 0.3s ease",
  },

  selectedCard: {
    border: "1px solid rgba(52,211,153,0.7)",

    boxShadow:
      "0 0 0 1px rgba(52,211,153,0.12), 0 20px 70px rgba(16,185,129,0.14)",
  },

  imageWrapper: {
    position: "relative",

    height: "260px",

    overflow: "hidden",
  },

  photo: {
    width: "100%",
    height: "100%",

    objectFit: "cover",

    display: "block",
  },

  imageOverlay: {
    position: "absolute",
    inset: 0,

    background:
      "linear-gradient(to top, rgba(4,10,8,0.95) 0%, rgba(4,10,8,0.1) 55%, transparent 100%)",
  },

  experienceBadge: {
    position: "absolute",

    top: "18px",
    right: "18px",

    display: "flex",
    alignItems: "center",
    gap: "6px",

    padding: "7px 11px",

    borderRadius: "999px",

    background: "rgba(0,0,0,0.55)",

    backdropFilter: "blur(10px)",

    border: "1px solid rgba(255,255,255,0.12)",

    color: "#f8fafc",

    fontSize: "12px",
  },

  selectedBadge: {
    position: "absolute",

    left: "18px",
    top: "18px",

    display: "flex",
    alignItems: "center",
    gap: "6px",

    padding: "7px 11px",

    borderRadius: "999px",

    background: "#10b981",

    color: "#022c22",

    fontSize: "12px",

    fontWeight: "800",
  },

  cardContent: {
    padding: "24px",
  },

  mentorHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    marginBottom: "22px",
  },

  mentorLabel: {
    margin: "0 0 4px",

    color: "#64748b",

    fontSize: "10px",

    letterSpacing: "2px",
  },

  name: {
    margin: 0,

    fontSize: "28px",

    fontWeight: "800",

    color: "#f8fafc",
  },

  marketIcon: {
    width: "46px",
    height: "46px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "14px",

    color: "#34d399",

    background: "rgba(16,185,129,0.08)",

    border: "1px solid rgba(16,185,129,0.15)",
  },

  marketBox: {
    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    padding: "13px 15px",

    marginBottom: "18px",

    borderRadius: "12px",

    background: "rgba(255,255,255,0.035)",

    border: "1px solid rgba(255,255,255,0.06)",
  },

  marketTitle: {
    fontSize: "12px",

    color: "#64748b",
  },

  marketValue: {
    fontSize: "13px",

    color: "#a7f3d0",

    fontWeight: "700",
  },

  description: {
    minHeight: "60px",

    margin: "0 0 24px",

    color: "#94a3b8",

    fontSize: "14px",

    lineHeight: "1.9",
  },

  button: {
    width: "100%",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    gap: "9px",

    padding: "14px 18px",

    border: "none",

    borderRadius: "12px",

    cursor: "pointer",

    fontSize: "14px",
    fontWeight: "700",

    color: "#022c22",

    background:
      "linear-gradient(135deg, #6ee7b7 0%, #34d399 45%, #10b981 100%)",

    boxShadow: "0 10px 30px rgba(16,185,129,0.18)",

    transition: "all 0.25s ease",
  },

  selectedButton: {
    background: "rgba(16,185,129,0.13)",

    color: "#6ee7b7",

    border: "1px solid rgba(52,211,153,0.25)",

    boxShadow: "none",

    cursor: "default",
  },

  glowOne: {
    position: "absolute",

    width: "500px",
    height: "500px",

    top: "-250px",
    right: "-150px",

    borderRadius: "50%",

    background: "rgba(16,185,129,0.10)",

    filter: "blur(100px)",

    pointerEvents: "none",
  },

  glowTwo: {
    position: "absolute",

    width: "400px",
    height: "400px",

    bottom: "-200px",
    left: "-100px",

    borderRadius: "50%",

    background: "rgba(6,95,70,0.16)",

    filter: "blur(120px)",

    pointerEvents: "none",
  },
};

export default FinancialMentors;